export default __webpack_public_path__ + "static/media/download-icon.f46a8034.svg";